import axios from 'axios';

const axiosService = axios.create({
    baseURL: process.env.REACT_APP_API_DOTNET,
});

/**
 * @param {import('axios').AxiosResponse} response
 */
const handleSuccess = (response) => response;

/**
 * @param {import('axios').AxiosRequestConfig} request
 */
const handleRequest = (request) => {
    request.headers = {
        Authorization: sessionStorage.getItem('authToken') ?? '',
    };
    return request;
};

/**
* @param {any} error
*/
const handleRequestError = (error) => Promise.reject(error);

/**
 * @param {any} error
 */
const handleError = (error) => {
    switch (error.response?.status) {
        case 401:
            if (error.response?.config?.baseURL === process.env.REACT_APP_API_DOTNET) {
                // sessionStorage.removeItem('authToken'); // TODO - remove since no jwt
                // sessionStorage.removeItem('jwtUserInfo');
                // sessionStorage.removeItem('jwtLifespan');
                // sessionStorage.removeItem('userInitials');
                // window.location.href = process.env.REACT_APP_UKG_URL || '';
            }
            break;
        case 404:
            // TODO: To be implemented ?!?
            break;
        default:
            break;
    }
    return Promise.reject(error);
};

/**
 * @param {*} error
 */
export const extractErrorMessage = (error) => error?.response?.data?.message || error.message || error.toString();

axiosService.interceptors.request.use(handleRequest, handleRequestError);
axiosService.interceptors.response.use(handleSuccess, handleError);
export default axiosService;
